<template>
  <section class="section">
    <div class="section-body">
      <div class="card" v-if="!isEdit">
        <div class="card-header">
          <v-icon color="pink">search</v-icon>
          <h4>{{ $t("messages.general.searchShowInfo") }}</h4>
        </div>
        <div class="card-body">
          <v-card width="100%">
            <v-row>
              <v-col
                cols="10"
                style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
              >
                <p style="color: red; margin: 0">*</p>
              </v-col>
              <v-col
                style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
              >
                <p style="margin: 0">{{ $t("messages.general.reqFields") }}</p>
              </v-col>
            </v-row>
          </v-card>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.academicYear") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <AcademicYear
                      :onChanged="onSelYearChanged"
                      :selectedVal="selYear"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.semester") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Semester
                      :onChanged="onSelSemesterChanged"
                      :selectedVal="selSemester"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.educationLvl") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Level
                      :onChanged="onSelLvlChanged"
                      :selectedVal="selLvl"
                      :disabled="false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.educationYear") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select class="form-control" v-model="selectedYear">
                        <option
                          v-for="(opt, idx) in selectedYearOpts"
                          v-bind:key="idx"
                          v-bind:value="opt.value"
                        >
                          {{ opt.text }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.faculty") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <Faculty
                      :onChanged="onSelFacultyChanged"
                      :selectedVal="selFaculty"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.department") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <Department
                      :onChanged="onSelDepartmentChanged"
                      :facultyid="selFaculty"
                      :selectedVal="selDepartment"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.educationCourse") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="input-group">
                          <div class="form-inline">
                            <div class="input-group-append">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              v-model="txtProgramCode"
                              @keypress="handleSearchProgramKey($event)"
                            />
                            <button
                              class="btn btn-primary btn-lg"
                              type="button"
                              @click="handleSearchProgram()"
                            >
                              <i class="fas fa-search"></i>
                            </button>
                          </div></div></div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              v-model="txtProgramName"
                              disabled
                            />
                            <button
                              class="btn btn-danger btn-lg"
                              type="button"
                              @click="clearSelectProgram()"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.from") }}
                      {{ $t("messages.general.identity") }}</label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="input-group">
                          <div class="form-inline">
                            <div class="input-group-append">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              v-model="txtStudentCodeFrom"
                              @keypress="handleSearchStudentFromKey($event)"
                            />
                            <button
                              class="btn btn-primary btn-lg"
                              type="button"
                              @click="openDialogSearch('from')"
                            >
                              <i class="fas fa-search"></i>
                            </button>
                          </div></div></div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              v-model="txtStudentNameFrom"
                              disabled
                            />
                            <button
                              class="btn btn-danger btn-lg"
                              type="button"
                              @click="clearStudentFrom()"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.to") }}
                      {{ $t("messages.general.identity") }}</label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="input-group">
                          <div class="form-inline">
                            <div class="input-group-append">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              v-model="txtStudentCodeTo"
                              @keypress="handleSearchStudentToKey($event)"
                            />
                            <button
                              class="btn btn-primary btn-lg"
                              type="button"
                              @click="openDialogSearch('to')"
                            >
                              <i class="fas fa-search"></i>
                            </button>
                          </div></div></div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              v-model="txtStudentNameTo"
                              disabled
                            />
                            <button
                              class="btn btn-danger btn-lg"
                              type="button"
                              @click="clearStudentTo()"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.classCode") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="input-group">
                          <div class="form-inline">
                            <div class="input-group-append">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              v-model="courseCode"
                              @keypress="handleSearchClsKey($event)"
                            />
                            <button
                              type="button"
                              class="btn btn-primary btn-lg"
                              @click="handleSearchCls()"
                            >
                              <i class="fas fa-search"></i>
                            </button>
                          </div></div></div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              disabled
                              v-model="courseName"
                            />
                            <button
                              type="button"
                              class="btn btn-danger btn-lg"
                              @click="handleClrCourse()"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.section") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select
                        class="form-control"
                        @change="onSelSectionChanged($event)"
                      >
                        <option :selected="selSection == '00'" value="00"
                          >---{{
                            $t("messages.general.notSpecified")
                          }}---</option
                        >
                        <option
                          v-for="(item, index) in sections"
                          :key="index"
                          :value="item.SECTION_TEXT"
                          :selected="selSection == item.SECTION_TEXT"
                        >
                          {{ item.SECTION_TEXT }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group" style="width: 100%">
                <div class="form-inline">
                  <div
                    class="form-group"
                    style="width: 60%; justify-content: center;"
                  >
                    <div class="form-inline">
                      <button
                        type="button"
                        class="btn btn-primary btn-lg"
                        @click="handleSearchStudent()"
                      >
                        {{ $t("messages.general.search") }}</button
                      >&nbsp;&nbsp;&nbsp;
                      <button
                        type="button"
                        class="btn btn-light btn-lg"
                        @click="clearAll()"
                      >
                        {{ $t("messages.general.clearScreen") }}</button
                      >&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                  <div
                    class="form-group"
                    style="width: 40%; justify-content: flex-end;"
                  >
                    <div class="form-inline">
                      <button
                        type="button"
                        class="btn btn-primary btn-lg"
                        @click="handleEnroll()"
                      >
                        {{ $t("messages.general.regisLearn") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <v-card>
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTable.sortBy"
              :sort-desc.sync="bTable.sortDesc"
              :items="bTable.items"
              :fields="bTable.fields"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTable.items.length"
                  v-model="currentPage"
                  :per-page="perPage"
                />
                <div
                  v-if="bTable.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPage > 1
                        ? (currentPage - 1) * perPage + 1
                        : currentPage
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPage * perPage > bTable.items.length
                        ? bTable.items.length
                        : currentPage * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTable.items.length).toLocaleString() }}
                </div>
                <div
                  v-if="bTable.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTable.items.length).toLocaleString() }}
                </div>
              </template>
              <template v-slot:head(action)="">
                <label>{{ $t("messages.general.regisLearn") }}</label
                ><br />
                <input
                  type="checkbox"
                  id="chkDelAll"
                  @change="handleDelChkAll($event)"
                  :checked="
                    bTable.items.length > 0 &&
                      bTable.items.length == studentList.length
                  "
                />
              </template>
              <template v-slot:cell(action)="data">
                <input
                  type="checkbox"
                  id="chkDel"
                  @change="handleDelChk($event, data)"
                  :checked="data.value"
                />
              </template>

              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTable.items.length"
                    v-model="currentPage"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTable.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPage > 1
                          ? (currentPage - 1) * perPage + 1
                          : currentPage
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPage * perPage > bTable.items.length
                          ? bTable.items.length
                          : currentPage * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTable.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTable.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTable.items.length).toLocaleString() }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>

          <v-dialog
            v-model="dialogSearchProgram"
            hide-overlay
            scrollable
            max-width="80%"
          >
            <v-card tile>
              <v-toolbar flat dense>
                <v-icon>search</v-icon>
                <v-toolbar-title>{{
                  $t("messages.general.programNameList")
                }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogSearchProgram = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark>
                <form>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{
                            $t("messages.general.programcode")
                          }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <div>
                            <input
                              v-model="dlgProgramCode"
                              type="text"
                              class="form-control col mr-2"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{
                            $t("messages.general.programName")
                          }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <div>
                            <input
                              v-model="dlgProgramName"
                              type="text"
                              class="form-control col mr-2"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.faculty") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <Faculty
                            :onChanged="onSelFacultyProgramChanged"
                            :selectedVal="selFacultyProgram"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.department") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <Department
                            :onChanged="onSelDepartmentProgramChanged"
                            :facultyid="selFacultyProgram"
                            :selectedVal="selDepartmentProgram"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label
                            >{{ $t("messages.general.educationLvl") }}
                          </label>
                        </div>
                        <div class="col no-margin-padding">
                          <Level
                            :onChanged="onSelLvlProgramChanged"
                            :selectedVal="selLvlProgram"
                            :disabled="false"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.yearRef") }} </label>
                        </div>
                        <div class="col no-margin-padding">
                          <AcademicYear
                            :onChanged="onSelYearProgramChanged"
                            :selectedVal="selYearProgram"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-row flex-column justify-content-center align-items-center mt-5"
                  >
                    <div class="form-group">
                      <div class="form-inline">
                        <button
                          class="btn btn-primary btn-lg"
                          type="button"
                          @click="handleProgramSearch(true)"
                        >
                          {{ $t("messages.general.search") }}</button
                        >&nbsp;&nbsp;&nbsp;
                        <button
                          class="btn btn-light btn-lg"
                          type="button"
                          @click="cleartSearchProgram()"
                        >
                          {{ $t("messages.general.clearScreen") }}</button
                        >&nbsp;&nbsp;&nbsp;
                      </div>
                    </div>
                  </div>
                </form>
                <v-card>
                  <b-table
                    bordered
                    hover
                    small
                    responsive
                    caption-top
                    class="table table-striped text-center"
                    :sort-by.sync="bTableProgram.sortBy"
                    :sort-desc.sync="bTableProgram.sortDesc"
                    :items="bTableProgram.items"
                    :fields="bTableProgram.fields"
                    :per-page="perPage"
                    :current-page="currentPageProgram"
                  >
                    <template slot="table-caption">
                      <div class="float-left">
                        <b class="mr-2">{{
                          $t("messages.general.table.paginationinfo")
                        }}</b>
                        <b-form-select
                          v-model="perPage"
                          :options="perPageOptions"
                          size="sm"
                          style="width:70px"
                        />
                      </div>
                      <b-pagination
                        class="float-right"
                        size="sm"
                        :total-rows="bTableProgram.items.length"
                        v-model="currentPageProgram"
                        :per-page="perPage"
                      />
                      <div
                        v-if="bTableProgram.items.length > 0"
                        class="float-right data-table-page-info"
                      >
                        {{
                          Number(
                            currentPageProgram > 1
                              ? (currentPageProgram - 1) * perPage + 1
                              : currentPageProgram
                          ).toLocaleString()
                        }}
                        -
                        {{
                          Number(
                            currentPageProgram * perPage >
                              bTableProgram.items.length
                              ? bTableProgram.items.length
                              : currentPageProgram * perPage
                          ).toLocaleString()
                        }}
                        {{ $t("messages.general.fromRecords") }}
                        {{
                          Number(bTableProgram.items.length).toLocaleString()
                        }}
                      </div>
                      <div
                        v-if="bTableProgram.items.length <= 0"
                        class="float-right data-table-page-info"
                      >
                        0 - 0
                        {{ $t("messages.general.fromRecords") }}
                        {{
                          Number(bTableProgram.items.length).toLocaleString()
                        }}
                      </div>
                    </template>

                    <template v-slot:cell(PROGRAMCODE)="data">
                      <a
                        @click="handleSelectProgram(data.item, data.index)"
                        style="text-decoration: underline;"
                      >
                        {{ data.item.PROGRAMCODE }}
                      </a>
                    </template>

                    <template slot="table-caption">
                      <div
                        style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                      >
                        <div class="float-left">
                          <b class="mr-2">{{
                            $t("messages.general.table.paginationinfo")
                          }}</b>
                          <b-form-select
                            v-model="perPage"
                            :options="perPageOptions"
                            size="sm"
                            style="width:70px"
                          />
                        </div>
                        <b-pagination
                          class="float-right"
                          size="sm"
                          :total-rows="bTableProgram.items.length"
                          v-model="currentPageProgram"
                          :per-page="perPage"
                          style="padding-top: 10px"
                        />
                        <div
                          v-if="bTableProgram.items.length > 0"
                          class="float-right data-table-page-info"
                          style="padding-top: 14px"
                        >
                          {{
                            Number(
                              currentPageProgram > 1
                                ? (currentPageProgram - 1) * perPage + 1
                                : currentPageProgram
                            ).toLocaleString()
                          }}
                          -
                          {{
                            Number(
                              currentPageProgram * perPage >
                                bTableProgram.items.length
                                ? bTableProgram.items.length
                                : currentPageProgram * perPage
                            ).toLocaleString()
                          }}
                          {{ $t("messages.general.fromRecords") }}
                          {{
                            Number(bTableProgram.items.length).toLocaleString()
                          }}
                        </div>
                        <div
                          v-if="bTableProgram.items.length <= 0"
                          class="float-right data-table-page-info"
                          style="padding-top: 14px"
                        >
                          0 - 0
                          {{ $t("messages.general.fromRecords") }}
                          {{
                            Number(bTableProgram.items.length).toLocaleString()
                          }}
                        </div>
                      </div>
                    </template>
                  </b-table>
                </v-card>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogSearch"
            hide-overlay
            scrollable
            max-width="80%"
          >
            <v-card tile>
              <v-toolbar flat dense>
                <v-icon>search</v-icon>
                <v-toolbar-title>{{
                  $t("messages.general.studentListName")
                }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogSearch = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark>
                <form>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.identity") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <div>
                            <input
                              v-model="dlgSearchStudentId"
                              type="text"
                              class="form-control col mr-2"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.fullname") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <div>
                            <input
                              v-model="dlgSearchStudentName"
                              type="text"
                              class="form-control col mr-2"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.faculty") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <Faculty
                            :onChanged="onSelFacultySearchChanged"
                            :selectedVal="selFacultySearch"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.department") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <Department
                            :onChanged="onSelDepartmentSearchChanged"
                            :facultyid="selFacultySearch"
                            :selectedVal="selDepartmentSearch"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label
                            >{{ $t("messages.general.educationLvl") }}
                          </label>
                        </div>
                        <div class="col no-margin-padding">
                          <Level
                            :onChanged="onSelLvlSearchChanged"
                            :selectedVal="selLvlSearch"
                            :disabled="false"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label
                            >{{ $t("messages.general.from") }}
                            {{ $t("messages.general.studentStatus") }}</label
                          >
                        </div>
                        <div class="col no-margin-padding">
                          <StudentStatus
                            :onChanged="onSelStudentStatusSearchFromChanged"
                            :selectedVal="selStudentStatusSearchFrom"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label
                            >{{ $t("messages.general.to") }}
                            {{ $t("messages.general.studentStatus") }}</label
                          >
                        </div>
                        <div class="col no-margin-padding">
                          <StudentStatus
                            :onChanged="onSelStudentStatusSearchToChanged"
                            :selectedVal="selStudentStatusSearchTo"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-row flex-column justify-content-center align-items-center mt-5"
                  >
                    <div class="form-group">
                      <div class="form-inline">
                        <button
                          class="btn btn-primary btn-lg"
                          type="button"
                          @click="handleSearchStudentCode()"
                        >
                          {{ $t("messages.general.search") }}</button
                        >&nbsp;&nbsp;&nbsp;
                        <button
                          class="btn btn-light btn-lg"
                          type="button"
                          @click="cleartSearchStudentCode()"
                        >
                          {{ $t("messages.general.clearScreen") }}</button
                        >&nbsp;&nbsp;&nbsp;
                      </div>
                    </div>
                  </div>
                </form>
                <v-card>
                  <b-table
                    bordered
                    hover
                    small
                    responsive
                    caption-top
                    class="table table-striped text-center"
                    :sort-by.sync="bTableSearch.sortBy"
                    :sort-desc.sync="bTableSearch.sortDesc"
                    :items="bTableSearch.items"
                    :fields="bTableSearch.fields"
                    :per-page="perPage"
                    :current-page="currentPageSearch"
                  >
                    <template slot="table-caption">
                      <div class="float-left">
                        <b class="mr-2">{{
                          $t("messages.general.table.paginationinfo")
                        }}</b>
                        <b-form-select
                          v-model="perPage"
                          :options="perPageOptions"
                          size="sm"
                          style="width:70px"
                        />
                      </div>
                      <b-pagination
                        class="float-right"
                        size="sm"
                        :total-rows="bTableSearch.items.length"
                        v-model="currentPageSearch"
                        :per-page="perPage"
                      />
                      <div
                        v-if="bTableSearch.items.length > 0"
                        class="float-right data-table-page-info"
                      >
                        {{
                          Number(
                            currentPageSearch > 1
                              ? (currentPageSearch - 1) * perPage + 1
                              : currentPageSearch
                          ).toLocaleString()
                        }}
                        -
                        {{
                          Number(
                            currentPageSearch * perPage >
                              bTableSearch.items.length
                              ? bTableSearch.items.length
                              : currentPageSearch * perPage
                          ).toLocaleString()
                        }}
                        {{ $t("messages.general.fromRecords") }}
                        {{ Number(bTableSearch.items.length).toLocaleString() }}
                      </div>
                      <div
                        v-if="bTableSearch.items.length <= 0"
                        class="float-right data-table-page-info"
                      >
                        0 - 0
                        {{ $t("messages.general.fromRecords") }}
                        {{ Number(bTableSearch.items.length).toLocaleString() }}
                      </div>
                    </template>

                    <template v-slot:cell(STUDENTID)="data">
                      <a
                        @click="handleSelectStudent(data.item, data.index)"
                        style="text-decoration: underline;"
                      >
                        {{ data.item.STUDENTID }}
                      </a>
                    </template>

                    <template slot="table-caption">
                      <div
                        style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                      >
                        <div class="float-left">
                          <b class="mr-2">{{
                            $t("messages.general.table.paginationinfo")
                          }}</b>
                          <b-form-select
                            v-model="perPage"
                            :options="perPageOptions"
                            size="sm"
                            style="width:70px"
                          />
                        </div>
                        <b-pagination
                          class="float-right"
                          size="sm"
                          :total-rows="bTableSearch.items.length"
                          v-model="currentPageSearch"
                          :per-page="perPage"
                          style="padding-top: 10px"
                        />
                        <div
                          v-if="bTableSearch.items.length > 0"
                          class="float-right data-table-page-info"
                          style="padding-top: 14px"
                        >
                          {{
                            Number(
                              currentPageSearch > 1
                                ? (currentPageSearch - 1) * perPage + 1
                                : currentPageSearch
                            ).toLocaleString()
                          }}
                          -
                          {{
                            Number(
                              currentPageSearch * perPage >
                                bTableSearch.items.length
                                ? bTableSearch.items.length
                                : currentPageSearch * perPage
                            ).toLocaleString()
                          }}
                          {{ $t("messages.general.fromRecords") }}
                          {{
                            Number(bTableSearch.items.length).toLocaleString()
                          }}
                        </div>
                        <div
                          v-if="bTableSearch.items.length <= 0"
                          class="float-right data-table-page-info"
                          style="padding-top: 14px"
                        >
                          0 - 0
                          {{ $t("messages.general.fromRecords") }}
                          {{
                            Number(bTableSearch.items.length).toLocaleString()
                          }}
                        </div>
                      </div>
                    </template>
                  </b-table>
                </v-card>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogStudentInfo"
            hide-overlay
            scrollable
            max-width="80%"
          >
            <v-card tile>
              <v-toolbar flat dense>
                <v-icon>mdi-file</v-icon>
                <v-toolbar-title>{{
                  $t("messages.general.showInfo")
                }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogStudentInfo = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark>
                <div class="information-block">
                  <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.identity") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <!-- <div>{{ selectedStudent.STUDENTID }}</div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.fullname") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <!-- <div>{{ selectedStudent.STUDENTID }}</div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.educationLvl") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <!-- <div>{{ selectedStudent.STUDENTID }}</div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.educationYear") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <!-- <div>{{ selectedStudent.STUDENTID }}</div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.faculty") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <!-- <div>{{ selectedStudent.STUDENTID }}</div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.department") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <!-- <div>{{ selectedStudent.STUDENTID }}</div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>
                            {{ $t("messages.general.educationCourse") }}
                          </div>
                        </div>
                        <div class="col no-margin-padding">
                          <!-- <div>{{ selectedStudent.STUDENTID }}</div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.academicYear") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <!-- <div>{{ selectedStudent.STUDENTID }}</div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.semester") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <!-- <div>{{ selectedStudent.STUDENTID }}</div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        ></div>
                        <div class="col no-margin-padding"></div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="row">
                  <div class="col no-padding-bottom">
                    <div class="information-detail-white">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 10em;"
                      ></div>
                      <div class="col no-margin-padding">
                        <button
                          class="btn btn-primary btn-lg"
                          @click="dialogStudentInfo = false"
                        >
                          {{ $t("messages.general.close") }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col no-padding-bottom">
                    <div class="information-detail">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 10em;"
                      ></div>
                      <div class="col no-margin-padding"></div>
                    </div>
                  </div>
                </div> -->
                  <br />
                  <div class="table-responsive">
                    <table class="table table-striped" id="table-epp1">
                      <thead>
                        <tr>
                          <th class="text-center">
                            {{ $t("messages.general.seqOrder") }}
                          </th>
                          <th class="text-center">
                            {{ $t("messages.general.classId") }}
                          </th>
                          <th class="text-center">
                            {{ $t("messages.general.className") }}
                          </th>
                          <th class="text-center">
                            {{ $t("messages.general.section") }}
                          </th>
                          <th class="text-center">
                            {{ $t("messages.general.reason") }}
                          </th>
                          <th class="text-center">
                            {{ $t("messages.general.periodRequest") }}
                          </th>
                          <th class="text-center">
                            {{ $t("messages.general.confirm") }}
                          </th>
                          <th class="text-center">
                            {{ $t("messages.general.resultApprove") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in selectedStudentData"
                          :key="index"
                        >
                          <td class="text-center">{{ index + 1 }}</td>
                          <td class="text-center">{{ item.COURSECODE }}</td>
                          <td v-html="item.COURSENAME">
                            {{ item.COURSENAME }}
                          </td>
                          <td class="text-center">
                            {{ item.SECTION }}
                          </td>
                          <td class="text-center">{{ item }}</td>
                          <td class="text-center">{{ item }}</td>
                          <td class="text-center">{{ item }}</td>
                          <td class="text-center">{{ item }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </div>
    <v-dialog
      v-model="dialogSearchCourse"
      hide-overlay
      scrollable
      max-width="80%"
    >
      <v-card tile>
        <v-toolbar flat dense>
          <v-icon>search</v-icon>
          <v-toolbar-title>{{
            $t("messages.general.classList")
          }}</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogSearchCourse = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark>
          <v-card width="100%">
            <v-row>
              <v-col
                class="text-danger"
                style="padding-top: 0; padding-bottom: 0; padding-right: 25px;"
              >
                <p style="margin: 0; text-align: right;">
                  {{ $t("messages.general.programCodeNameReq") }}
                </p>
              </v-col>
            </v-row>
          </v-card>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.classId") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <input
                        v-model="dlgCourseCode"
                        type="text"
                        class="form-control col mr-2"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.className") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <input
                        v-model="dlgCourseName"
                        type="text"
                        class="form-control col mr-2"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.faculty") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <Faculty
                      :onChanged="onSelFacultyCourseChanged"
                      :selectedVal="selFacultyCourse"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.department") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <Department
                      :onChanged="onSelDepartmentCourseChanged"
                      :facultyid="selFacultyCourse"
                      :selectedVal="selDepartmentCourse"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    class="btn btn-primary btn-lg"
                    type="button"
                    @click="handleCourseSearch()"
                  >
                    {{ $t("messages.general.search") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    class="btn btn-light btn-lg"
                    type="button"
                    @click="clearCourse()"
                  >
                    {{ $t("messages.general.clearScreen") }}</button
                  >&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
          </form>
          <v-card>
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTableCourse.sortBy"
              :sort-desc.sync="bTableCourse.sortDesc"
              :items="bTableCourse.items"
              :fields="bTableCourse.fields"
              :per-page="perPage"
              :current-page="currentPageProgram"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTableCourse.items.length"
                  v-model="currentPageProgram"
                  :per-page="perPage"
                />
                <div
                  v-if="bTableCourse.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPageProgram > 1
                        ? (currentPageProgram - 1) * perPage + 1
                        : currentPageProgram
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPageProgram * perPage > bTableCourse.items.length
                        ? bTableCourse.items.length
                        : currentPageProgram * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTableCourse.items.length).toLocaleString() }}
                </div>
                <div
                  v-if="bTableCourse.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTableCourse.items.length).toLocaleString() }}
                </div>
              </template>

              <template v-slot:cell(COURSECODE)="data">
                <a
                  @click="handleSelectCourse(data.item, data.index)"
                  style="text-decoration: underline;"
                >
                  {{ data.item.COURSECODE }}
                </a>
              </template>

              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTableCourse.items.length"
                    v-model="currentPageProgram"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTableCourse.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPageProgram > 1
                          ? (currentPageProgram - 1) * perPage + 1
                          : currentPageProgram
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPageProgram * perPage > bTableCourse.items.length
                          ? bTableCourse.items.length
                          : currentPageProgram * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableCourse.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTableCourse.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableCourse.items.length).toLocaleString() }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirmSuccess" max-width="600px">
      <v-card tile>
        <v-toolbar flat dense color="light-green accent-3">
          <v-icon color="light-green darken-2">fa-check</v-icon>
          <v-toolbar-title style="color: green;"
            >&nbsp;{{
              $t("messages.reqRegister.confirmPopupText")
            }}</v-toolbar-title
          >
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogConfirmSuccess = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark color="green accent-1">
          <br />
          <span v-html="successText" style="color: green;">{{
            successText
          }}</span>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogError" max-width="600px">
      <v-card tile>
        <v-toolbar flat dense color="red darken-3">
          <v-icon color="red lighten-5">fa-exclamation-circle</v-icon>
          <v-toolbar-title style="color: #ffebee;"
            >&nbsp;{{ dialogErrorTitle }}</v-toolbar-title
          >
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogError = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark color="red accent-1">
          <br />
          <span style="color: red;" v-html="errorText">{{ errorText }}</span>
        </v-card-text>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import AcademicYear from "../components/Dropdown/AcademicYear";
import Semester from "../components/Dropdown/Semester";
import Level from "@/components/Dropdown/Level.vue";
import Faculty from "@/components/Dropdown/Faculty.vue";
import Department from "@/components/Dropdown/Department.vue";
import StudentStatus from "@/components/Dropdown/StudentStatus.vue";
import EnrollProvider from "@/services/enroll_provider";
import MasterDataProvider from "@/services/masterData_provider";

const masterDataProvider = new MasterDataProvider();
const enrollProvider = new EnrollProvider();

export default {
  name: "cancelReqEnrollment",
  components: {
    AcademicYear,
    Semester,
    Level,
    Faculty,
    Department,
    StudentStatus,
  },
  data() {
    return {
      dialogSearchProgram: false,
      dialogError: false,
      dialogSearchCourse: false,
      dialogSearch: false,
      dialogStudentInfo: false,
      selectedDetail: false,
      selYear: 0,
      selSemester: 0,
      selLvl: 0,
      selFaculty: 0,
      selDepartment: 0,
      isEdit: false,
      selFacultySearch: 0,
      selDepartmentSearch: 0,
      selLvlSearch: 0,
      selStudentStatusSearchFrom: 0,
      selStudentStatusSearchTo: 0,
      studentList: [],
      sections: [],
      selSection: "00",
      dlgCourseCode: "",
      courseCode: "",
      courseName: "",
      dlgCourseName: "",
      selDepartmentCourse: 0,
      selFacultyCourse: 0,
      dialogConfirmSuccess: false,
      successText: "",
      dialogError: false,
      errorText: "",
      dialogErrorTitle: "",
      bTable: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "STUDENTCODE",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            thStyle: "width: 110px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "STUDENTNAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "COURSEID",
            label: this.$t("messages.general.classId"),
            thClass: "align-middle",
            thStyle: "width: 100px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "COURSENAMEENG",
            label: this.$t("messages.general.className"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "SECTION",
            label: this.$t("messages.general.section"),
            thClass: "align-middle",
            thStyle: "width: 80px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "PRICE",
            label: this.$t("messages.general.fee"),
            thClass: "align-middle",
            thStyle: "width: 100px",
            tdClass: "text-rigth text-nowarp",
            sortable: true,
          },
          {
            key: "action",
            label: "",
            thClass: "align-middle",
            thStyle: "width: 100px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
        ],
      },
      perPageOptions: [
        { value: 10, text: 10 },
        { value: 50, text: 50 },
        { value: 100, text: 100 },
        { value: 500, text: 500 },
        { value: 1000, text: 1000 },
        { value: 2000, text: 2000 },
        { value: 3000, text: 3000 },
      ],
      perPage: 100,
      currentPage: 1,
      currentPageSearch: 1,
      currentPageProgram: 1,
      dlgSearchStudentId: "",
      dlgSearchStudentName: "",
      // bTableStudent: {
      //   sortBy: "rowNumber",
      //   sortDesc: false,
      //   items: [],
      //   fields: [],
      // },
      bTableSearch: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "STUDENTID",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            thStyle: "width: 110px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "FULLNAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            thStyle: "width: 170px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "DEPARTMENTGROUPNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            thStyle: "width: 170px",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "LEVELNAME",
            label: this.$t("messages.general.educationLvl"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
        ],
      },
      bTableCourse: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "COURSECODE",
            label: this.$t("messages.general.classId"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "COURSENAME",
            label: this.$t("messages.general.className"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            thStyle: "width: 170px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "DEPARTMENTNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            thStyle: "width: 170px",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "COURSEUNIT",
            label: this.$t("messages.general.credit"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
        ],
      },
      bTableProgram: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "PROGRAMCODE",
            label: this.$t("messages.general.programcode"),
            thClass: "align-middle",
            thStyle: "width: 110px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "PROGRAMNAME",
            label: this.$t("messages.general.programName"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            thStyle: "width: 170px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "DEPARTMENTNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            thStyle: "width: 170px",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "LEVELNAME",
            label: this.$t("messages.general.educationLvl"),
            thClass: "align-middle",
            thStyle: "width: 150px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "PROGRAMYEAR",
            label: this.$t("messages.general.yearRef"),
            thClass: "align-middle",
            thStyle: "width: 100px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
        ],
      },
      searchSelIdx: 0,
      selectedStudentIdx: 0,
      selectedStudent: false,
      selectedStudentData: [],
      programs: [],
      infoFormStatus: 2,
      regStatus: 0,
      dlgProgramCode: "",
      dlgProgramName: "",
      selFacultyProgram: 0,
      selDepartmentProgram: 0,
      selLvlProgram: 0,
      selYearProgram: 0,
      txtProgramCode: "",
      txtProgramName: "",
      programSelIdx: 0,
      selectedYear: 0,
      selectedYearOpts: [
        { text: this.$t("messages.general.notSpecified"), value: 0 },
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 },
        { text: "5", value: 5 },
        { text: "6", value: 6 },
        { text: "7", value: 7 },
        { text: "8", value: 8 },
      ],
      studentCodeMode: "",
      txtStudentCodeFrom: "",
      txtStudentNameFrom: "",
      txtStudentCodeTo: "",
      txtStudentNameTo: "",
      selItem: 0,
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken",
      userId: "getUserId",
      mfuUserId: "getMfuUserId",
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    },
  },
  mounted() {
    this.tokenHealthChk();
    this.togglePreLoader(true);
    this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
    this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
    this.selLvl = 3;
    this.selLvlSearch = 3;
    this.selLvlProgram = 3;
    this.selYearProgram = this.appInfo.data.ENROLL_ACADYEAR;
    this.selItem = 0;
    this.togglePreLoader(false);
  },
  methods: {
    ...mapActions("application", [
      "togglePreLoader",
      "tokenHealthChk",
      "setStudentInfo",
    ]),
    async openDialogSearch(mode) {
      this.togglePreLoader(true);
      if (this.txtStudentCodeFrom != "" && mode == "from") {
        const result = await this.handleSearchStudentKey(
          this.txtStudentCodeFrom,
          mode
        );
        if (result) {
          this.txtStudentCodeFrom = result.code;
          this.txtStudentNameFrom = result.name;
        } else {
          this.txtStudentNameFrom = "";
        }
      } else if (this.txtStudentCodeTo != "" && mode == "to") {
        const result = await this.handleSearchStudentKey(
          this.txtStudentCodeTo,
          mode
        );
        if (result) {
          this.txtStudentCodeTo = result.code;
          this.txtStudentNameTo = result.name;
        } else {
          this.txtStudentNameTo = "";
        }
      } else {
        this.cleartSearchStudentCode();
        this.dialogSearch = true;
        this.studentCodeMode = mode;
      }
      this.togglePreLoader(false);
    },
    async openDialogStudentInfo(data, idx) {
      this.togglePreLoader(true);
      this.dialogStudentInfo = true;
      this.selectedStudentIdx = idx;
      this.selectedStudent = data;
      this.togglePreLoader(false);
    },
    onSelFacultyCourseChanged() {
      this.selFacultyCourse = parseInt(event.target.value);
    },
    onSelDepartmentCourseChanged(event) {
      this.selDepartmentCourse = parseInt(event.target.value);
    },
    onSelYearChanged(event) {
      this.selYear = parseInt(event.target.value);
    },
    onSelSemesterChanged(event) {
      this.selSemester = parseInt(event.target.value);
    },
    onSelLvlChanged(event) {
      this.selLvl = parseInt(event.target.value);
    },
    onSelFacultyChanged(event) {
      this.selFaculty = parseInt(event.target.value);
    },
    onSelDepartmentChanged(event) {
      this.selDepartment = parseInt(event.target.value);
    },
    onSelFacultySearchChanged(event) {
      this.selFacultySearch = parseInt(event.target.value);
    },
    onSelDepartmentSearchChanged(event) {
      this.selDepartmentSearch = parseInt(event.target.value);
    },
    onSelLvlSearchChanged(event) {
      this.selLvlSearch = parseInt(event.target.value);
    },
    onSelStudentStatusSearchFromChanged(event) {
      this.selStudentStatusSearchFrom = parseInt(event.target.value);
    },
    onSelStudentStatusSearchToChanged(event) {
      this.selStudentStatusSearchTo = parseInt(event.target.value);
    },
    onSelFacultyProgramChanged(event) {
      this.selFacultyProgram = parseInt(event.target.value);
    },
    onSelDepartmentProgramChanged(event) {
      this.selDepartmentProgram = parseInt(event.target.value);
    },
    onSelLvlProgramChanged(event) {
      this.selLvlProgram = parseInt(event.target.value);
    },
    onSelYearProgramChanged(event) {
      this.selYearProgram = parseInt(event.target.value);
    },
    onSelSectionChanged(event) {
      this.selSection = event.target.value;
    },
    handleSearchClsKey(event) {
      if (event.charCode == 13) {
        this.handleSearchCls();
      }
    },
    async handleSearchCls() {
      if (this.courseCode != "") {
        this.togglePreLoader(true);
        const data = await enrollProvider.searchCourse({
          token: this.token,
          request: {
            coursecode: this.courseCode,
            lang: this.currentLang,
          },
        });
        // Fix Dropdown Course List Found Multiple Course
        if (data.length > 0) {
          if (data.length === 1) {
            this.handleSelectClass(data[0]);
            this.courseList = data;
          } else {
            this.courseList = data;
            this.dlgCourseCode = this.courseCode;
            this.dialogSearchCourse = true;
            this.bTableCourse.items = [];
            if (data.length > 0) {
              let idx = 0;
              data.map((d) => {
                d.rowNumber = idx + 1;
                this.bTableCourse.items.push(d);
                idx++;
              });
            }
          }
        }
        this.togglePreLoader(false);
      } else {
        this.handleShowDlgSearchCourse();
      }
    },
    async handleSelectClass(item) {
      if (item && item.COURSECODE != null) {
        this.courseCode = item.COURSECODE;
        this.courseName = item.COURSENAME;
        await this.getSections();
      }
    },
    async getSections() {
      if (this.selYear != 0 && this.selSemester != 0 && this.courseCode != "") {
        this.togglePreLoader(true);
        const data = await masterDataProvider.getSection({
          token: this.token,
          request: {
            acadyear: this.selYear,
            semester: this.selSemester,
            coursecode: this.courseCode,
            lang: this.currentLang,
          },
        });
        this.sections = data;
        this.togglePreLoader(false);
      }
    },
    async handleSelectCourse(item, idx) {
      console.log(idx);
      this.courseCode = item.COURSECODE;
      this.courseName = item.COURSENAME;
      await this.getSections();
      this.dialogSearchCourse = false;
    },
    handleClrCourse() {
      this.courseCode = "";
      this.courseName = "";
      this.sections = [];
    },
    handleShowDlgSearchCourse() {
      this.clearCourse();
      this.dialogSearchCourse = true;
    },
    async handleCourseSearch() {
      if (this.dlgCourseCode != "" || this.dlgCourseName != "") {
        this.togglePreLoader(true);
        const result = await enrollProvider.searchCourse({
          token: this.token,
          request: {
            coursecode: this.dlgCourseCode,
            coursename: this.dlgCourseName,
            facultyid: this.selFacultyCourse,
            departmentid: this.selDepartmentCourse,
            lang: this.currentLang,
          },
        });
        this.bTableCourse.items = [];
        if (result.length > 0) {
          let idx = 0;
          result.map((d) => {
            d.rowNumber = idx + 1;
            this.bTableCourse.items.push(d);
            idx++;
          });
        }
        this.togglePreLoader(false);
      } else {
        this.dialogError = true;
        this.errorText = this.$t("messages.general.programCodeNameReq");
      }
    },
    clearCourse() {
      this.dlgCourseCode = "";
      this.dlgCourseName = "";
      this.selFacultyCourse = 0;
      this.selDepartmentCourse = 0;
      this.bTableCourse.items = [];
    },
    handleSelectStudent(data, idx) {
      this.searchSelIdx = idx;
      if (this.studentCodeMode == "from") {
        this.txtStudentCodeFrom = data.STUDENTCODE;
        this.txtStudentNameFrom = data.FULLNAME;
      } else {
        this.txtStudentCodeTo = data.STUDENTCODE;
        this.txtStudentNameTo = data.FULLNAME;
      }
      this.dialogSearch = false;
    },
    handleSelectProgram(data, idx) {
      this.programSelIdx = idx;
      this.txtProgramCode = data.PROGRAMCODE;
      this.txtProgramName = data.PROGRAMNAME;
      this.dialogSearchProgram = false;
      this.cleartSearchProgram();
    },
    goBack() {
      this.totalConfirm = 0;
      this.selected = false;
      this.selectedIdx = 0;
      this.selectedDetail = false;
      //this.extraReg = false;
      this.isEdit = false;
      //this.studentIdList = [];
      this.studentList = [];
      //this.dialogRandom = false;
      this.handleSearchStudent();
    },
    clearSelectProgram() {
      this.txtProgramCode = "";
      this.txtProgramName = "";
    },
    async getPrograms() {
      this.togglePreLoader(true);
      const params = {
        token: this.token,
        request: {
          lang: this.currentLang,
          programyear: this.selYearProgram,
          levelid: this.selLvl,
        },
      };
      if (this.selFacultyProgram != 0) {
        params.request.facultyid = this.selFacultyProgram;
      }
      if (this.selDepartmentProgram != 0) {
        params.request.departmentid = this.selDepartmentProgram;
      }
      if (this.dlgProgramCode != "") {
        params.request.programcode = this.dlgProgramCode;
      }
      if (this.dlgProgramName != "") {
        params.request.programname = this.dlgProgramName;
      }
      const result = await enrollProvider.getSearchProgram(params);
      this.togglePreLoader(false);
      return result;
    },
    async handleSearchStudent() {
      if (this.selYear != 0 && this.selSemester != 0 && this.selLvl != -1) {
        this.togglePreLoader(true);
        const result = await enrollProvider.getEnrollpstatus({
          token: this.token,
          request: {
            acadyear: this.selYear,
            semester: this.selSemester,
            levelid: this.selLvl,
            studentyear: this.selectedYear,
            facultyid: this.selFaculty,
            departmentid: this.selDepartment,
            programid: this.txtProgramCode,
            studentidfrom: this.txtStudentCodeFrom,
            studentidto: this.txtStudentCodeTo,
            courseid: this.courseCode,
            section: this.selSection,
            lang: this.currentLang,
          },
        });
        this.bTable.items = [];
        if (result.length > 0) {
          this.searched = true;
          let idx = 0;
          result.map((d) => {
            d.rowNumber = idx + 1;
            this.bTable.items.push(d);
            idx++;
          });
        }
        this.togglePreLoader(false);

        console.log("this.bTable.items", this.bTable.items);
      }
    },
    async handleSearchStudentCode() {
      this.togglePreLoader(true);
      const params = {
        token: this.token,
        request: {
          levelid: this.selLvlSearch,
          lang: this.currentLang,
        },
      };
      if (this.dlgSearchStudentId != 0) {
        params.request.studentcode = this.dlgSearchStudentId;
      }
      if (this.dlgSearchStudentName != "") {
        params.request.studentname = this.dlgSearchStudentName;
      }
      if (this.selFacultySearch != 0) {
        params.request.facultyid = this.selFacultySearch;
      }
      if (this.selDepartmentSearch != 0) {
        params.request.departmentid = this.selDepartmentSearch;
      }
      if (this.selStudentStatusSearchFrom != 0) {
        params.request.studentstatusfrom = this.selStudentStatusSearchFrom;
      }
      if (this.selStudentStatusSearchTo != 0) {
        params.request.studentstatusto = this.selStudentStatusSearchTo;
      }
      const result = await enrollProvider.searchStudentCode(params);
      this.bTableSearch.items = [];
      if (result.length > 0) {
        let idx = 0;
        if (!result[idx].hasOwnProperty("ERR_DESC")) {
          result.map((d) => {
            d.rowNumber = idx + 1;
            d.FULLNAME = `${d.PREFIXNAME} ${d.STUDENTNAME} ${d.STUDENTSURNAME}`;
            this.bTableSearch.items.push(d);
            idx++;
          });
        }
      }
      this.togglePreLoader(false);
    },
    async handleSearchProgramKey(event) {
      if (event.charCode == 13) {
        this.dlgProgramCode = this.txtProgramCode;
        this.handleProgramSearch(false);
      }
    },
    handleSearchProgram() {
      this.cleartSearchProgram();
      this.dialogSearchProgram = true;
    },
    cleartSearchProgram() {
      this.dlgProgramCode = "";
      this.dlgProgramName = "";
      this.selFacultyProgram = 0;
      this.selDepartmentProgram = 0;
      this.selLvlProgram = 3;
      this.selYearProgram = this.appInfo.data.ENROLL_ACADYEAR;
      this.bTableProgram.items = [];
    },
    cleartSearchStudentCode() {
      this.studentCodeMode = "";
      this.dlgSearchStudentId = "";
      this.dlgSearchStudentName = "";
      this.selFacultySearch = 0;
      this.selDepartmentSearch = 0;
      this.selLvlSearch = 3;
      this.selStudentStatusSearchFrom = 0;
      this.selStudentStatusSearchTo = 0;
      this.bTableSearch.items = [];
    },
    async handleEnroll() {
      this.togglePreLoader(true);
      const selList = this.bTable.items.filter((d) => d.action == true);
      const resIp = await masterDataProvider.getCurrentIP();
      console.log("selList", selList);
      let listErrMsg = "";
      let resMsg = "";
      for (let i = 0; i < selList.length; i++) {
        const item = selList[i];
        const temp = {
          token: this.token,
          request: {
            studentid: item.STUDENTCODE,
            acadyear: this.selYear,
            semester: this.selSemester,
            classid: item.CLASSID,
            fee : +item.PRICE,
            userid: this.mfuUserId,
            ipaddress: resIp.ip,
            lang: this.currentLang,
          },
        };
        const result = await enrollProvider.saveEnrollstatus(temp);
        if (result.status != 200) {
          listErrMsg += `${result.message}<br/>`;
        } else {
          resMsg = `${result.message}<br/>`;
        }
      }
      this.togglePreLoader(false);
      if (listErrMsg != "") {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${listErrMsg}`;
      } else {
        this.dialogConfirmSuccess = true;
        this.successText = `${resMsg}`;
      }
    },
    clearAll() {
      this.cleartSearchProgram();
      this.cleartSearchStudentCode();
      this.clearSelectProgram();
      this.clearStudentFrom();
      this.clearStudentTo();
      this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
      this.selSemester = 1;
      this.selLvl = 3;
      this.infoFormStatus = 2;
      this.regStatus = 0;
      this.selFaculty = 0;
      this.selDepartment = 0;
      this.selectedYear = 0;
      this.handleClrCourse();
    },
    clearStudentFrom() {
      this.txtStudentCodeFrom = "";
      this.txtStudentNameFrom = "";
    },
    clearStudentTo() {
      this.txtStudentCodeTo = "";
      this.txtStudentNameTo = "";
    },
   async handleProgramSearch(isPopup) {
      const result = await this.getPrograms();
      if (result.length > 0) {
        if (
          !isPopup &&
          (result.length == 1 || result[0].PROGRAMCODE == this.txtProgramCode)
        ) {
          this.txtProgramCode = result[0].PROGRAMCODE;
          this.txtProgramName = result[0].PROGRAMNAME;
        } else {
          this.dialogSearchProgram = true;
          this.bTableProgram.items = [];
          let idx = 0;
          result.map((d) => {
            d.rowNumber = idx + 1;
            this.bTableProgram.items.push(d);
            idx++;
          });
        }
      } else {
        this.dialogSearchProgram = true;
        this.bTableProgram.items = [];
      }
    },
    async handleSelect(data, idx) {
      this.selItem = idx;
      const menus = await masterDataProvider.getMenu({
        token: this.token,
        userId: data.STUDENTID,
        lang: this.currentLang,
      });
      this.setStudentInfo({
        studentId: data.STUDENTID,
        data: data,
        menus: menus,
      });
      this.$router.push("/");
    },
     async handleSearchStudentFromKey(event) {
      if (event.charCode == 13 && this.txtStudentCodeFrom != "") {
        this.handleSearchStudentKey(
          this.txtStudentCodeFrom,
          "from"
        );
      }
    },
    async handleSearchStudentToKey(event) {
      if (event.charCode == 13 && this.txtStudentCodeTo != "") {
        this.handleSearchStudentKey(
          this.txtStudentCodeTo,
          "to"
        );
      }
    },
    handleDelChkAll(e) {
      const isChecked = e.target.checked;
      this.bTable.items.map((i) => {
        i.action = e.target.checked;
        if (isChecked) {
          this.studentList.push(i.STUDENTID);
        }
      });
      if (!isChecked) {
        this.studentList = [];
      }
    },
    handleDelChk(e, data) {
      const isChecked = e.target.checked;
      const { item, index } = data;
      this.bTable.items[index].action = isChecked;
      if (isChecked) {
        this.studentList.push(item.CLASSID);
      } else {
        const newArr = this.studentList.filter((s) => s != item.STUDENTID);
        this.studentList = newArr;
      }
    },
    // goTo(item, index, mode) {
    //   this.totalConfirm = 0;
    //   this.selected = item;
    //   this.selectedIdx = index;
    //   this.selectedClsId = this.selected.CLASSID;
    //   //this.studentIdList = [];
    //   this.studentList = [];
    //   console.log("goto mode", mode);
    //   this.mode = mode;
    //   this.isEdit = true;
    //   this.bTableStudent.fields = [
    //     {
    //       key: "action",
    //       label: "",
    //       thClass: "align-middle",
    //       thStyle: "width: 50px",
    //       tdClass: "text-center text-nowarp",
    //       sortable: true,
    //     },
    //     {
    //       key: "rowNumber",
    //       label: this.$t("messages.general.seqOrder"),
    //       thClass: "align-middle",
    //       thStyle: "width: 50px",
    //       tdClass: "text-center text-nowarp",
    //       sortable: true,
    //     },
    //     {
    //       key: "CLASSID",
    //       label: this.$t("messages.general.classId"),
    //       thClass: "align-middle",
    //       thStyle: "width: 110px",
    //       tdClass: "text-center text-nowarp",
    //       sortable: true,
    //     },
    //     {
    //       key: "CLASSNAME",
    //       label: this.$t("messages.general.className"),
    //       thClass: "align-middle",
    //       tdClass: "text-left",
    //       sortable: true,
    //     },
    //     {
    //       key: "SECTION",
    //       label: this.$t("messages.general.section"),
    //       thClass: "align-middle",
    //       thStyle: "width: 100px",
    //       tdClass: "text-center text-nowarp",
    //       sortable: true,
    //     },
    //     {
    //       key: "REASON",
    //       label: this.$t("messages.general.reason"),
    //       thClass: "align-middle",
    //       tdClass: "text-left text-nowarp",
    //       sortable: true,
    //     },
    //     {
    //       key: "CONFIRM",
    //       label: this.$t("messages.general.confirm"),
    //       thClass: "align-middle",
    //       tdClass: "text-left text-nowarp",
    //       sortable: true,
    //     },
    //     {
    //       key: "RESULTAPPROVE",
    //       label: this.$t("messages.general.resultApprove"),
    //       thClass: "align-middle",
    //       tdClass: "text-left text-nowarp",
    //       sortable: true,
    //     },
    //   ];
    // },

    async handleSearchStudentKey(code, mode) {
      const params = {
        token: this.token,
        request: {
          levelid: this.selLvlSearch,
          lang: this.currentLang,
        },
      };
      console.log('mode handleSearchStudentKey', mode)
      params.request.studentcode = code;
      this.studentCodeMode = mode;
      this.togglePreLoader(true);
      const result = await enrollProvider.searchStudentCode(params);
      this.togglePreLoader(false);
      console.log('result handleSearchStudentKey', result)
      if (mode == "from" && result.length > 0 && (result.length == 1 || result[0].STUDENTCODE == code)) {
        this.txtStudentCodeFrom = result[0].STUDENTCODE;
        this.txtStudentNameFrom = `${result[0].PREFIXNAME}${result[0].STUDENTNAME} ${result[0].STUDENTSURNAME}`;
      }else if(mode == "to" && result.length > 0 && (result.length == 1 || result[0].STUDENTCODE == code)){
        this.txtStudentCodeTo = result[0].STUDENTCODE;
        this.txtStudentNameTo = `${result[0].PREFIXNAME}${result[0].STUDENTNAME} ${result[0].STUDENTSURNAME}`;
      } else {
        this.dlgSearchStudentId =
        mode == "from" ? this.txtStudentCodeFrom : this.txtStudentCodeTo;
        this.dialogSearch = true;
        this.handleSearchStudentCode();
      }
    },
  },
  watch: {
    async currentLang() {
      // this.bTableStudent.fields = [
      //   {
      //     key: "action",
      //     label: "",
      //     thClass: "align-middle",
      //     thStyle: "width: 50px",
      //     tdClass: "text-center text-nowarp",
      //     sortable: true,
      //   },
      //   {
      //     key: "rowNumber",
      //     label: this.$t("messages.general.seqOrder"),
      //     thClass: "align-middle",
      //     thStyle: "width: 50px",
      //     tdClass: "text-center text-nowarp",
      //     sortable: true,
      //   },
      //   {
      //     key: "CLASSID",
      //     label: this.$t("messages.general.classId"),
      //     thClass: "align-middle",
      //     thStyle: "width: 110px",
      //     tdClass: "text-center text-nowarp",
      //     sortable: true,
      //   },
      //   {
      //     key: "CLASSNAME",
      //     label: this.$t("messages.general.className"),
      //     thClass: "align-middle",
      //     tdClass: "text-left",
      //     sortable: true,
      //   },
      //   {
      //     key: "SECTION",
      //     label: this.$t("messages.general.section"),
      //     thClass: "align-middle",
      //     thStyle: "width: 100px",
      //     tdClass: "text-center text-nowarp",
      //     sortable: true,
      //   },
      //   {
      //     key: "REASON",
      //     label: this.$t("messages.general.reason"),
      //     thClass: "align-middle",
      //     tdClass: "text-left text-nowarp",
      //     sortable: true,
      //   },
      //   {
      //     key: "CONFIRM",
      //     label: this.$t("messages.general.confirm"),
      //     thClass: "align-middle",
      //     tdClass: "text-left text-nowarp",
      //     sortable: true,
      //   },
      //   {
      //     key: "RESULTAPPROVE",
      //     label: this.$t("messages.general.resultApprove"),
      //     thClass: "align-middle",
      //     tdClass: "text-left text-nowarp",
      //     sortable: true,
      //   },
      // ];
      this.bTableProgram.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "PROGRAMCODE",
          label: this.$t("messages.general.programcode"),
          thClass: "align-middle",
          thStyle: "width: 110px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "PROGRAMNAME",
          label: this.$t("messages.general.programName"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          thStyle: "width: 170px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "DEPARTMENTNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          thStyle: "width: 170px",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "LEVELNAME",
          label: this.$t("messages.general.educationLvl"),
          thClass: "align-middle",
          thStyle: "width: 150px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "PROGRAMYEAR",
          label: this.$t("messages.general.yearRef"),
          thClass: "align-middle",
          thStyle: "width: 100px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
      ];
      this.bTableSearch.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "STUDENTID",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          thStyle: "width: 110px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "FULLNAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          thStyle: "width: 170px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "DEPARTMENTGROUPNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          thStyle: "width: 170px",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "LEVELNAME",
          label: this.$t("messages.general.educationLvl"),
          thClass: "align-middle",
          thStyle: "width: 110px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
      ];
      this.bTable.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "STUDENTCODE",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          thStyle: "width: 110px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "STUDENTNAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "COURSEID",
          label: this.$t("messages.general.classId"),
          thClass: "align-middle",
          thStyle: "width: 100px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "COURSENAMEENG",
          label: this.$t("messages.general.className"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "SECTION",
          label: this.$t("messages.general.section"),
          thClass: "align-middle",
          thStyle: "width: 80px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "PRICE",
          label: this.$t("messages.general.fee"),
          thClass: "align-middle",
          thStyle: "width: 100px",
          tdClass: "text-rigth text-nowarp",
          sortable: true,
        },
        {
          key: "action",
          label: "",
          thClass: "align-middle",
          thStyle: "width: 100px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
      ];
      this.bTableCourse.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "COURSECODE",
          label: this.$t("messages.general.classId"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "COURSENAME",
          label: this.$t("messages.general.className"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          thStyle: "width: 170px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "DEPARTMENTNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          thStyle: "width: 170px",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "COURSEUNIT",
          label: this.$t("messages.general.credit"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
      ];
      await this.handleSearchStudent();
      this.selectedYearOpts = [
        { text: this.$t("messages.general.notSpecified"), value: 0 },
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 },
        { text: "5", value: 5 },
        { text: "6", value: 6 },
        { text: "7", value: 7 },
        { text: "8", value: 8 },
      ];
    },
  },
};
</script>
